module.exports = __webpack_public_path__ + "static/img/Inspection6.41599da1.png";